// removed by extract-text-webpack-plugin
module.exports = {"propertyInfoBlock":"yHLZr2apXqwIyhsOGyagJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/components/CellInfoIconsBlock/CellInfoIconsBlock.scss
// module id = 1652
// module chunks = 0